import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import ClienteService from '../../../business-api/ClienteService'

import {
    adicionaNaoInformar
} from '../../../business-components/Array/Array'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2xs6,
    GridItem3xs6,
    GridItem9xs5,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
    CardGridEntradaDadosHeaderBodyDivider,
} from '../../../business-components/Card/Card'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorText,
    TextValidatorTextDestaque,
    TextValidatorTextMultiline,
    TextValidatorNumber,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectRequired,
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoFormaPagtoPremioList from '../../../business-rules/List/tipoFormaPagtoPremioList'

import statusPropostaList from '../../../business-rules/List/SeguroVida/statusPropostaList'

import seguradoraList from '../../../business-rules/List/SeguroVida/seguradoraList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha,
    ButtonVisualizarPDFLeft,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    getArquivoConteudo,
} from '../../arquivo/ArquivoService'

import {
    obtemArquivoProposta,
} from '../acompanhamento-form/AcompanhamentoServiceArquivo'

import {
    processaAlteracaoSeguroVidaApoliceSeguradora,
} from '../seguroVida-form/SeguroVidaServiceSeguroVidaApolice'

import {
    incrementaContSeguroVidaProposta,
    processaValoresDefaultIniciaisSeguroVidaProposta,
} from './SeguroVidaPropostaServiceProposta'

import {
    incluiSeguroVidaPropostaCoberturaDefault,
    excluirPropostaCoberturas,
} from './SeguroVidaPropostaServiceCobertura'

import SeguroVidaPropostaFormCobertura from './SeguroVidaPropostaFormCobertura'


const SeguroVidaPropostaFormProposta = ({ variaveisGlobais, values, handleChange, setFieldValue, vars, arquivoList }) => {
    
    return (
        <FieldArray name="seguroVidaProposta">
            {(arrayHelpers) => (
                <DivForm>
                    <GridContainer>
                        {values.seguroVidaProposta?.map((item, ind) => {

                            processaValoresDefaultIniciaisSeguroVidaProposta(item)

                            const arquivoProposta = obtemArquivoProposta(arquivoList, item.numeroProposta)
                            
                            return item.familiar === Number.parseInt(values.familiarSeguroVidaProposta)
                            ? (
                                <GridItem12
                                    key={ind}
                                >
                                    <CardGridEntradaDados
                                        className='mb-5'
                                    >
                                        <GridContainer>
                                            <GridItem12
                                                className='mt-2'
                                                align='center'
                                            >
                                                <h1>
                                                    {LABEL.proposta}
                                                </h1>
                                            </GridItem12>
                                        </GridContainer>
                                    </CardGridEntradaDados>

                                    <CardGridEntradaDados>
                                        <CardGridDivHeaderEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextValidatorTextDestaque
                                                        name={`seguroVidaProposta[${ind}].numeroProposta`}
                                                        //placeholder={LABEL.numeroProposta}
                                                        label={LABEL.numeroProposta}
                                                        value={item.numeroProposta|| ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroProposta}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem9xs5
                                                    className='mt-4'
                                                >
                                                    {arquivoProposta && (
                                                        <CustomizedDialogsViewPDF
                                                            maxWidth='xl'
                                                            align='left'
                                                            popupTitle={arquivoProposta.nomeArquivo}
                                                            PopupButton={ButtonVisualizarPDFLeft}
                                                            carregarPDF={async () => {
                                                                const arquivoArquivoAcessoDTO =
                                                                    await getArquivoConteudo(variaveisGlobais,
                                                                        ClienteService.obterUsuarioClienteSelecionado(
                                                                            variaveisGlobais), arquivoProposta.idArquivo)
                        
                                                                return arquivoArquivoAcessoDTO.conteudo
                                                            }}
                                                            //pdfFile={pdf}
                                                        />
                                                    )}
                                                </GridItem9xs5>
                                                
                                                <GridItem1>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() => {
                                                            excluirPropostaCoberturas(values, item.id)

                                                            arrayHelpers.remove(ind)
                                                        }}
                                                    />
                                                </GridItem1>
                                            </GridContainer>
                                        </CardGridDivHeaderEntradaDados>

                                        <CardGridDivBodyEntradaDados>
                                            <GridContainer>
                                                <GridItem2xs6>
                                                    <TextFieldNumberSelect
                                                        name={`seguroVidaProposta[${ind}].seguradora`}
                                                        label={LABEL.seguradora}
                                                        value={item.seguradora || ''}
                                                        onChange={handleChange}
                                                        list={seguradoraList()}
                                                        onBlur={processaAlteracaoSeguroVidaApoliceSeguradora(item)}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6
                                                    style={{
                                                        display:
                                                            item.seguradora === HARDCODE.idSeguradoraOutras 
                                                                ? "block"
                                                                : "none"
                                                    }}
                                                >
                                                    <TextValidatorText
                                                        name={`seguroVidaProposta[${ind}].seguradoraOutras`}
                                                        label={LABEL.seguradoraOutras}
                                                        value={item.seguradoraOutras || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.seguradoraOutras}
                                                    />
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <MuiPickersUtilsProviderPadrao>
                                                        <KeyboardDatePickerPadrao
                                                            name={`seguroVidaProposta[${ind}].dataAssinatura`}
                                                            label={LABEL.dataAssinatura}
                                                            value={item.dataAssinatura}
                                                            onChange={(date) => {
                                                                setFieldValue(
                                                                    `seguroVidaProposta[${ind}].dataAssinatura`,
                                                                    date,
                                                                )}
                                                            }
                                                        />
                                                    </MuiPickersUtilsProviderPadrao>
                                                </GridItem2xs6>

                                                <GridItem2xs6>
                                                    <TextFieldTextSelectRequired
                                                        name={`seguroVidaProposta[${ind}].tipoPeriodicidadePagtoPremio`}
                                                        label={LABEL.tipoPeriodicidadePagtoPremio}
                                                        value={item.tipoPeriodicidadePagtoPremio || ''}
                                                        onChange={handleChange}
                                                        list={tipoPeriodicidadeList(false, true, false)}
                                                    />
                                                </GridItem2xs6>
                                                
                                                {item.tipoFormaPagtoPremio && (
                                                    <GridItem2xs6>
                                                        <TextFieldTextSelect
                                                            name={`seguroVidaProposta[${ind}].tipoFormaPagtoPremio`}
                                                            label={LABEL.tipoFormaPagto}
                                                            value={item.tipoFormaPagtoPremio || ''}
                                                            onChange={handleChange}
                                                            list={tipoFormaPagtoPremioList}
                                                        />
                                                    </GridItem2xs6>
                                                )}

                                                {item.valorPremioAnualizado && (
                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`seguroVidaProposta[${ind}].valorPremioAnualizado`}
                                                            label={LABEL.valorPremioAnualizado}
                                                            value={item.valorPremioAnualizado === 0 ? 0 : item.valorPremioAnualizado || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>
                                                )}

                                                <GridItem2xs6>
                                                    <TextFieldTextSelect
                                                        name={`seguroVidaProposta[${ind}].statusProposta`}
                                                        label={LABEL.statusProposta}
                                                        value={item.statusProposta || ''}
                                                        onChange={handleChange}
                                                        list={statusPropostaList}
                                                    />
                                                </GridItem2xs6>

                                                {item.dataUltimaAlteracao && (
                                                    <GridItem2xs6>
                                                        <MuiPickersUtilsProviderPadrao>
                                                            <KeyboardDatePickerPadrao
                                                                name={`seguroVidaProposta[${ind}].dataUltimaAlteracao`}
                                                                label={LABEL.dataUltimaAlteracao}
                                                                value={item.dataUltimaAlteracao}
                                                                onChange={(date) => {
                                                                    setFieldValue(
                                                                        `seguroVidaProposta[${ind}].dataUltimaAlteracao`,
                                                                        date,
                                                                    )}
                                                                }
                                                            />
                                                        </MuiPickersUtilsProviderPadrao>
                                                    </GridItem2xs6>
                                                )}

                                                <GridItem2xs6>
                                                    <TextValidatorText
                                                        name={`seguroVidaProposta[${ind}].numeroCotacao`}
                                                        label={LABEL.numeroCotacao}
                                                        value={item.numeroCotacao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.numeroCotacao}
                                                    />
                                                </GridItem2xs6>

                                                {vars.jsonConfiguracao.habilitarDivisaoComissaoSeguroVida &&
                                                vars.linhaPerfil.podeInformarDivisaoComissaoSeguroVida === 'S' && (
                                                    <>
                                                        <GridItem3xs6>
                                                            <TextFieldTextSelect
                                                                name={`seguroVidaProposta[${ind}].idCorretorSeguros`}
                                                                label={LABEL.idCorretorSeguros}
                                                                value={item.idCorretorSeguros || ''}
                                                                onChange={handleChange}
                                                                list={adicionaNaoInformar(vars.equipeList)}
                                                            />
                                                        </GridItem3xs6>

                                                        {item.idCorretorSeguros && (
                                                            <GridItem2xs6>
                                                                <TextValidatorNumber
                                                                    name={`seguroVidaProposta[${ind}].percDivisaoComissao`}
                                                                    label={LABEL.percDivisaoComissao}
                                                                    value={item.percDivisaoComissao === 0 ? 0 : item.percDivisaoComissao || ''}
                                                                    onChange={handleChange}
                                                                    numMin={NUMMIN.perc}
                                                                    numMax={NUMMAX.perc}
                                                                />
                                                            </GridItem2xs6>
                                                        )}

                                                        {item.percDivisaoComissao && item.percDivisaoComissao !== 100 && (
                                                            <GridItem3xs6>
                                                                <TextFieldTextSelect
                                                                    name={`seguroVidaProposta[${ind}].idCorretorSeguros2`}
                                                                    label={LABEL.idCorretorSeguros2}
                                                                    value={item.idCorretorSeguros2 || ''}
                                                                    onChange={handleChange}
                                                                    list={adicionaNaoInformar(vars.equipeList)}
                                                                />
                                                            </GridItem3xs6>
                                                        )}

                                                        <GridItem2xs6>
                                                            <TextValidatorText
                                                                name={`seguroVidaProposta[${ind}].codigoAgenteAssessorInvestimentos`}
                                                                label={LABEL.codigoAgenteAssessorInvestimentos}
                                                                value={item.codigoAgenteAssessorInvestimentos || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.codigoAgente}
                                                            />
                                                        </GridItem2xs6>
                                                    </>
                                                )}
                                            </GridContainer>
                                            
                                            <GridContainer>
                                                <GridItem12>
                                                    <TextValidatorTextMultiline
                                                        name={`seguroVidaProposta[${ind}].observacao`}
                                                        label={LABEL.observacao}
                                                        value={item.observacao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.observacao}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                        </CardGridDivBodyEntradaDados>
                                        
                                        <CardGridEntradaDadosHeaderBodyDivider
                                            title={LABEL.coberturas}
                                        >
                                            <SeguroVidaPropostaFormCobertura
                                                idSeguroVidaProposta={item.id}
                                                integracao={item.integracao}
                                                values={values}
                                                handleChange={handleChange}
                                                setFieldValue={setFieldValue}
                                            />
                                        </CardGridEntradaDadosHeaderBodyDivider>
                                    </CardGridEntradaDados>
                                </GridItem12>
                            )
                            :
                            (
                                ''
                            )
                        })}
                    </GridContainer>

                    <ButtonIncluirLinha
                        label={LABEL.buttonIncluirSeguroVidaProposta} 
                        disabled={familiaresList(values).length === 0 || !values.familiarSeguroVidaProposta ? true : false}
                        onClick={() =>
                            {
                                incrementaContSeguroVidaProposta(values)
                                incluiSeguroVidaPropostaCoberturaDefault (values, values.contSeguroVidaProposta)
                                arrayHelpers.push({
                                    id: values.contSeguroVidaProposta,
                                    familiar: Number.parseInt(values.familiarSeguroVidaProposta),
                                })
                            }
                        }
                    />
                </DivForm>
            )}
        </FieldArray>
    )
}

export default SeguroVidaPropostaFormProposta